import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { FeatureState } from '../state/feature.state';

@Injectable({ providedIn: 'root' })
export class CanActivateChildFeatureGuard implements CanActivateChild {
  constructor(private store: Store) {}

  canActivateChild(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | boolean {
    if (route.data && route.data.featureId) {
      const featId = route.data.featureId;
      return this.store.select((state) =>
        FeatureState.isFeatureEnabled(state)(featId)
      );
    }

    return true;
  }
}
